// src/lib/forfeoExternalLinks.ts
// Liens officiels entre Forfeo Explore et Forfeo.com.
// Forfeo Explore inspire et aide à choisir; Forfeo.com reste la vitrine transactionnelle officielle pour la carte virtuelle Forfeo.

export const FORFEO_EXPLORE_URL =
  (import.meta as any)?.env?.VITE_FORFEO_EXPLORE_URL || 'https://forfeoexplore.com';

export const FORFEO_COM_URL =
  (import.meta as any)?.env?.VITE_FORFEO_GIFTSHOP_URL ||
  (import.meta as any)?.env?.VITE_FORFEO_TRANSACTIONAL_URL ||
  'https://forfeo.com';

const trimTrailingSlash = (value: string) => String(value || '').replace(/\/+$/, '');

export const getForfeoComUrl = (path = '/') => {
  const base = trimTrailingSlash(FORFEO_COM_URL || 'https://forfeo.com');
  const cleanPath = String(path || '/').startsWith('/') ? String(path || '/') : `/${path}`;
  return `${base}${cleanPath}`;
};

export const getForfeoExploreUrl = (path = '/') => {
  const base = trimTrailingSlash(FORFEO_EXPLORE_URL || 'https://forfeoexplore.com');
  const cleanPath = String(path || '/').startsWith('/') ? String(path || '/') : `/${path}`;
  return `${base}${cleanPath}`;
};

export const FORFEO_GIFT_CARD_URL = getForfeoComUrl('/carte-cadeau');
export const FORFEO_SHOP_URL = getForfeoComUrl('/boutique');
export const FORFEO_EXPLORE_HOME_URL = getForfeoExploreUrl('/');

export type ForfeoExternalDestination = {
  label: string;
  url: string;
  description?: string;
};

export const forfeoExternalDestinations = {
  giftCard: {
    label: 'Carte virtuelle Forfeo',
    url: FORFEO_GIFT_CARD_URL,
    description: 'Achat sécurisé sur forfeo.com',
  },
  shop: {
    label: 'Boutique Forfeo',
    url: FORFEO_SHOP_URL,
    description: 'Vitrine transactionnelle officielle',
  },
} satisfies Record<string, ForfeoExternalDestination>;
